import { interfaces } from 'inversify';

export type MetasitePermissionLevel = {
  id: string
  value: string
  name: string
}[];

export default ({ container }: interfaces.Context) => {
  const i18n: any = container.get('TranslationCrate.i18n');

  return [
    {
      id: 'no-access',
      value: 'no-access',
      name: i18n.t('administration:meta-sites.details.permissions.levels.no-access'),
    },
    {
      id: 'view',
      value: 'view',
      name: i18n.t('administration:meta-sites.details.permissions.levels.view'),
    },
    {
      id: 'edit',
      value: 'edit',
      name: i18n.t('administration:meta-sites.details.permissions.levels.edit'),
    },
    {
      id: 'manage',
      value: 'manage',
      name: i18n.t('administration:meta-sites.details.permissions.levels.manage'),
    },
  ];
};
